@if (maintenance.active()) {
<main
  class="min-h-[100dvh] w-full flex items-center justify-center p-6 bg-slate-900 text-slate-100 selection:bg-emerald-500 selection:text-white maintenance-screen"
  role="alertdialog" aria-labelledby="maintenance-title" aria-describedby="maintenance-desc">
  <div
    class="max-w-md w-full bg-slate-900/90 border border-slate-800 rounded-3xl p-8 shadow-2xl text-center space-y-6 backdrop-blur-md">
    <div
      class="w-20 h-20 mx-auto rounded-2xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center p-3 shadow-inner overflow-hidden">
      <img src="/icons/lom-192.png" alt="League of Managers" class="w-full h-full object-contain drop-shadow"
        referrerpolicy="no-referrer" />
    </div>
    <div class="space-y-2">
      <span
        class="inline-block px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">
        Mantenimiento programado
      </span>
      <h1 id="maintenance-title" class="text-2xl font-black tracking-tight text-white">
        Estamos actualizando LOM
      </h1>
      <p id="maintenance-desc" class="text-sm text-slate-400 leading-relaxed">
        Estamos realizando labores de optimización y mantenimiento en el servidor. Volveremos en unos minutos.
      </p>
    </div>

    <div
      class="p-4 rounded-2xl bg-slate-950/60 border border-slate-800/80 text-xs text-slate-300 flex items-center justify-center space-x-2.5"
      role="status" aria-live="polite">
      <div class="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-ping shrink-0"></div>
      <span>Comprobando el estado del servidor automáticamente…</span>
    </div>

    <p class="text-[11px] text-slate-500 leading-normal pt-2">
      Tu sesión se conserva de forma segura. En cuanto el servicio vuelva a estar disponible, la aplicación se
      reconectará automáticamente.
    </p>
  </div>
</main>
} @else {
<div [attr.inert]="pwa.connectionLost() ? '' : null" [hidden]="pwa.connectionLost()">
  <!-- Global Toast Notification Banner -->
  @if (game.notification(); as notif) {
  <div
    class="fixed top-4 right-4 z-50 max-w-sm w-full p-4 rounded-2xl border shadow-xl flex items-start space-x-3 transition-all animate-bounce"
    [ngClass]="
      notif.type === 'error'
        ? 'bg-rose-50 border-rose-200 text-rose-800 dark:bg-rose-950/90 dark:border-rose-800 dark:text-rose-200'
        : notif.type === 'warning'
        ? 'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-950/90 dark:border-amber-800 dark:text-amber-200'
        : notif.type === 'info'
        ? 'bg-sky-50 border-sky-200 text-sky-800 dark:bg-sky-950/90 dark:border-sky-800 dark:text-sky-200'
        : 'bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-emerald-950/90 dark:border-emerald-800 dark:text-emerald-200'
    ">
    <app-icon
      [name]="notif.type === 'error' ? 'alert-circle' : notif.type === 'warning' ? 'alert-triangle' : notif.type === 'info' ? 'info' : 'check-circle'"
      [size]="20" />
    <div class="flex-1 text-xs font-semibold">
      {{ notif.message }}
    </div>
    <button (click)="game.dismissNotification()" class="opacity-70 hover:opacity-100 cursor-pointer">
      <app-icon name="x" [size]="14" />
    </button>
  </div>
  }

  <!-- Primary Angular Router Shell -->
  <router-outlet />


</div>
<app-pwa-controls />
}